// DateTimeSelector.js  
  
import React from 'react';  
import {  
  Card,  
  DatePicker,  
  TimePicker,  
  Row,  
  Col,  
  Typography,  
} from 'antd';  
const { Title } = Typography;  
const { RangePicker } = DatePicker;
  
const DateTimeSelector = ({  
  dateList,  
  setDateRange,
  times,  
  onTimeChange,  
}) => {  
  const selectedRange =
    dateList.length > 0
      ? [dateList[0], dateList[dateList.length - 1]]
      : null;
  
  return (  
    <>  
      <div style={{ marginBottom: '20px' }}>
        <RangePicker
          value={selectedRange}
          onChange={(range) => {
            if (!range || !range[0] || !range[1]) {
              setDateRange(null, null);
              return;
            }
            setDateRange(range[0], range[1]);
          }}
          format="YYYY-MM-DD"
        />
      </div>
      {/* Selected dates list */}  
      {dateList.map((date) => {  
        const dateStr = date.format('YYYY-MM-DD');  
  
        return (  
          <Card key={dateStr} style={{ marginBottom: '10px' }}>  
            <Row gutter={16} align="middle">  
              <Col span={6}>  
                <Title level={5}>{date.format('dddd, MMMM D, YYYY')}</Title>  
              </Col>  
              <Col span={9}>  
                <TimePicker  
                  placeholder="Start Time"  
                  value={times[dateStr]?.startTime}  
                  onSelect={(time) => onTimeChange(dateStr, 'startTime', time)}  
                  style={{ width: '100%' }}  
                  format="HH:mm"  
                />  
              </Col>  
              <Col span={9}>  
                <TimePicker  
                  placeholder="End Time"  
                  value={times[dateStr]?.endTime}  
                  onSelect={(time) => onTimeChange(dateStr, 'endTime', time)}  
                  style={{ width: '100%' }}  
                  format="HH:mm"  
                />  
              </Col>  
            </Row>  
          </Card>  
        );  
      })}  
    </>  
  );  
};  
  
export default DateTimeSelector;  